import api from "./apis";
import {
  ERROR_MESSAGE,
  LOADED,
  LOADING,
  SUCCESS_MESSAGE,
  VALIDATION_ERROR,
} from "./types";
import history from "../history";

export const getFBatches =
  (p, client, batch, payment, review, ds, de) => async (dispatch) => {
    dispatch({ type: LOADING });
    try {
      let response = null;
      if (ds && de) {
        response = await api(localStorage.getItem("token")).get(
          `/finance-management/batch?p=${p ? p : 1}&client=${
            client ? client : ""
          }&batch=${batch ? batch : ""}&payment=${
            payment ? payment : ""
          }&review=${review ? review : ""}&ds=${ds ? ds : ""}&de=${
            de ? de : ""
          }`
        );
      } else {
        response = await api(localStorage.getItem("token")).get(
          `/finance-management/batch?p=${p ? p : 1}&client=${
            client ? client : ""
          }&batch=${batch ? batch : ""}&payment=${
            payment ? payment : ""
          }&review=${review ? review : ""}`
        );
      }

      if (response.status === 200) {
        dispatch({ type: LOADED });
        return response.data;
      }
    } catch (err) {
      /* =============Start========== */
      if (err?.response?.status === 422) {
        err.response.data.errors.map((item) => {
          dispatch({
            type: VALIDATION_ERROR,
            payload: [{ message: item.message, path: item.path[0] }],
          });
        });
      }
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
        localStorage.clear();
        history.push("/login");
      }
      dispatch({
        type: ERROR_MESSAGE,
        payload: err.response
          ? err.response.data.message
          : history.push("/opps"),
      });
      dispatch({ type: LOADED });
      /* ===========End============*/
    }
  };

export const getFDetails = (id) => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const response = await api(localStorage.getItem("token")).get(
      `/finance-management/batch/detail?batch=${id}`
    );
    if (response.status === 200) {
      dispatch({ type: LOADED });
      return response.data.batch;
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};
export const getClientStatic = (user_id) => async (dispatch) => {
  dispatch({ type: LOADING });
  try {
    const response = await api(localStorage.getItem("token")).get(
      `/client-management/client/statistics?client=${user_id}`
    );

    if (response.status === 200) {
      dispatch({ type: LOADED });
      return response.data;
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const updatePaymentReview = (id, remark) => async (dispatch) => {
  dispatch({ type: LOADING });

  try {
    const obj = {
      batch: id,
      remark: remark.remark,
    };
    const response = await api(localStorage.getItem("token")).patch(
      "/finance-management/payment/review",
      { ...obj }
    );

    // console.log(response);

    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Operation successful",
      });

      dispatch({ type: LOADED });
      return response.status;
    } else {
      dispatch({ type: LOADED });
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};

export const updateConfirmPayment = (id, remark) => async (dispatch) => {
  dispatch({ type: LOADING });

  try {
    const obj = {
      batch: id,
      remark: remark.remark,
    };
    const response = await api(localStorage.getItem("token")).patch(
      "/finance-management/payment",
      { ...obj }
    );

    // console.log(response);

    if (response.status === 201) {
      dispatch({
        type: SUCCESS_MESSAGE,
        payload: "Operation successful",
      });

      dispatch({ type: LOADED });
      return response.status;
    } else {
      dispatch({ type: LOADED });
    }
  } catch (err) {
    /* =============Start========== */
    if (err?.response?.status === 422) {
      err.response.data.errors.map((item) => {
        dispatch({
          type: VALIDATION_ERROR,
          payload: [{ message: item.message, path: item.path[0] }],
        });
      });
    }
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message });
      localStorage.clear();
      history.push("/login");
    }
    dispatch({
      type: ERROR_MESSAGE,
      payload: err.response ? err.response.data.message : history.push("/opps"),
    });
    dispatch({ type: LOADED });
    /* ===========End============*/
  }
};
